import FontIcon from './FontIcon.vue';
import withInstall from '@/shared/withInstall';

export const XFontIcon = withInstall(FontIcon);
export default XFontIcon;
